import React from 'react';
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Stack
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { postRequest } from '../../../../lib/api';
import BreadcrumbsWrapper from '../../../../components/breadcrumbs'

export default function CreateSubstatus() {
  const navigate = useNavigate();

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors }
  } = useForm({
    defaultValues: {
      parent_status: '',
      status: '',
       is_active: true,
    }
  });

  const onSubmit = async (data) => {
    console.log(data , 'DATAAAAA')

     const finalData = {
    ...data,
     is_active: data.is_active ? 'true' : 'false',
  };
  console.log(finalData , 'finalData@1321')

    try {
      const response = await postRequest('private/createStatusSubStatus', finalData);
      console.log('API Success:', response.data);
      navigate(-1);
    } catch (error) {
      console.error('API Error:', error);
    }
  };

  return (
    <>
        <BreadcrumbsWrapper
                                                            items={[
                                                              { label: 'Dashboard', path: '/dashboard' },
                                                              { label: 'StatusSubStatus', path: '/system-setup/LeadSubStatuses' },
                                                              { label: 'CreateStatusSubStatus', path: '' },
                                                             
                                                            ]}
                                                          />
                                                    <br></br>

                                                      <Box px={4} py={3}>
      <Typography variant="h5" mb={3} sx={{ fontWeight: 600 }}>
        Add New Lead Sub-Status
      </Typography>

      <form onSubmit={handleSubmit(onSubmit)}>
        {/* Parent Status */}
        <FormControl fullWidth margin="normal" error={!!errors.parent_status}>
          <InputLabel>Parent Status</InputLabel>
          <Controller
            name="parent_status"
            control={control}
            rules={{ required: 'Parent status is required' }}
            render={({ field }) => (
              <Select {...field} label="Parent Status">
                <MenuItem value="Quote Sent">Quote Sent</MenuItem>
                <MenuItem value="Instructed">Instructed</MenuItem>
                <MenuItem value="Exported">Exported</MenuItem>
                <MenuItem value="Not Interested">Not Interested</MenuItem>
              </Select>
            )}
          />
          {errors.parent_status && (
            <Typography variant="caption" color="error">
              {errors.parent_status.message}
            </Typography>
          )}
        </FormControl>

        {/* Status */}
        <Controller
          name="status"
          control={control}
          rules={{ required: 'Status is required' }}
          render={({ field }) => (
            <TextField
              {...field}
              label="Sub-Status"
              fullWidth
              margin="normal"
              error={!!errors.status}
              helperText={errors.status?.message}
            />
          )}
        />

        {/* Checkbox */}
        <FormControlLabel
          sx={{ mt: 2 }}
          control={
            <Controller
              name="is_active"
              control={control}
              render={({ field }) => (
                <Checkbox {...field} checked={field.value} color="primary" />
              )}
            />
          }
          label="Is Active"
        />

        {/* Buttons */}
        <Stack direction="row" spacing={2} mt={4}>
          <Button variant="outlined" color="inherit" onClick={() => navigate(-1)}>
            Cancel
          </Button>
          <Button type="submit" variant="contained" className='red-bg red-button text-capitalize'>
            Submit
          </Button>
        </Stack>
      </form>
    </Box>
    </>
  
  );
}
